import { CloseRounded } from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import Txt from "../../../../components/typography/Txt";
import { isNil } from "lodash";

const CommentAttachmentChip = ({
  children,
  icon,
  onClick,
  onDelete,
  attachmentId,
  endContent,
  background,
  color,
  tooltip,
  imagePreview,
}) => {
  const content = (
    <Box
      // onClick={onClick}
      sx={{
        alignItems: "center",
        gap: 0.4,
        borderRadius: "8px",
        display: "flex",
        padding: "4px 5px",
        border: "1px solid #dde0e4",
        background: `${background} !important`,
        color: `${color} !important    `,
        fontSize: "10px !important",
        position: "relative",
        paddingLeft: imagePreview ? "40px" : undefined,
        minHeight: imagePreview ? "32px" : undefined,
        ".MuiButton-icon": {
          mx: 0.2,
        },
        ".MuiSvgIcon-root": {
          fontSize: "14px !important",
        },
      }}
      color="gray"
    >
      {!imagePreview ? icon : null}

      <ImagePreviewBox imagePreview={imagePreview} />
      <Typography
        onClick={onClick}
        sx={{
          maxWidth: "200px",
          overflow: "hidden",
          cursor: isNil(onClick) ? "default" : "pointer",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: 400,
          lineHeight: 1.75,
          fontSize: "10px",
          mr: 1,
        }}
      >
        {children}
      </Typography>
      {endContent}
      {onDelete && (
        <Tooltip title="Remove">
          <IconButton
            onClick={() => onDelete(attachmentId)}
            sx={{ p: 0, color: "inherit" }}
            size="small"
          >
            <CloseRounded className="thin" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );

  return tooltip ? <Tooltip title={tooltip}>{content}</Tooltip> : content;
};

const ImagePreviewBox = ({ imagePreview }) => {
  if (isNil(imagePreview)) {
    return null;
  }
  return (
    <Box
      sx={{
        position: "absolute",
        left: 4,
        top: "50%",
        transform: "translateY(-50%)",
        width: 24,
        height: 24,
        borderRadius: "4px",
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
        background: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={imagePreview}
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export default CommentAttachmentChip;
